module.exports = __webpack_public_path__ + "img/tiandi-propa.55d620f6.png";